import React from 'react';
import { IconCalendar } from 'components/Icons';
import { VendorTemplate } from '@hone-automation/common';

interface APAgingReportConfigurationButtonProps {
  toggleModal: () => void;
  currentReport: 'AP Aging' | VendorTemplate;
}

function APAgingReportConfigurationButton({ toggleModal, currentReport }: APAgingReportConfigurationButtonProps) {
  return (
    <button className="report-dates-control" onClick={toggleModal}>
      <div className="report-dates-control-period">{currentReport}</div>
      <div className="report-dates-control-range">Configure Report</div>
    </button>
  );
}

export default APAgingReportConfigurationButton;
